module.exports = __webpack_public_path__ + "img/background.fd56f12a.jpg";